import { NavLink, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { brandAssets } from "@/constants/brand";

const navItems = [
  { to: "/dashboard", label: "War Rooms", testId: "nav-war-rooms-link" },
  { to: "/profile", label: "Account", testId: "nav-account-link" },
  { to: "/admin", label: "Admin", testId: "nav-admin-link" },
];

export const AppShell = ({ children, variant = "default" }) => {
  const { user, logout } = useAuth();

  return (
    <div className="app-shell" data-testid="app-shell">
      <header
        className={`w-full border-b border-stone-800 ${
          variant === "room" ? "bg-stone-950/80 backdrop-blur-xl" : "bg-stone-950/90"
        }`}
        data-testid="app-header"
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex flex-wrap items-center justify-between gap-4">
          <Link to="/dashboard" className="flex items-center gap-3" data-testid="brand-home-link">
            <div className="h-12 w-12 rounded-full overflow-hidden border border-red-900/50">
              <img
                src={brandAssets.logo}
                alt="Dracon Gaming"
                className="h-full w-full object-cover"
                data-testid="brand-logo-image"
              />
            </div>
            <div>
              <p className="font-cinzel text-lg text-stone-100" data-testid="brand-title">
                Dracon Gaming
              </p>
              <p className="text-xs uppercase tracking-[0.3em] text-stone-500" data-testid="brand-subtitle">
                Dystopian VTT
              </p>
            </div>
          </Link>
          <nav className="flex flex-wrap items-center gap-6" data-testid="app-navigation">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.3em] transition-colors duration-300 ${
                    isActive ? "text-red-200" : "text-stone-400 hover:text-stone-100"
                  }`
                }
                data-testid={item.testId}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-4" data-testid="app-user-panel">
            <div>
              <p className="text-xs text-stone-500 uppercase tracking-[0.35em]" data-testid="user-label">
                Bound Player
              </p>
              <p className="font-cinzel text-stone-200" data-testid="user-name">
                {user?.username || "Wanderer"}
              </p>
            </div>
            <Button
              variant="secondary"
              className="border border-stone-700 text-stone-200 hover:text-stone-100"
              onClick={logout}
              data-testid="logout-button"
            >
              Exit Sanctum
            </Button>
          </div>
        </div>
      </header>
      <main
        className={variant === "room" ? "relative" : "max-w-6xl mx-auto px-6 py-10"}
        data-testid="app-shell-content"
      >
        {children}
      </main>
    </div>
  );
};
